import api from "../api";
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    userCollections: {},
    filterQuantity: 0,
    collections: {}
  },
  getters: {
    
  },
  actions: {
    async get_userCollections({ commit }, payload) {
      try {
        api.get(`/v1/userCollections?vision=${payload.vision}&order_by=${payload.order_by}`,)
          .then((res) => {
            commit("GET_USERSCOLLECTIONS", res.data);
          })
          .catch((error) => {
            commit("ERROR_USERSCOLLECTION", "Erro ao carregar os user collection");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_USERSCOLLECTION", e);
      }
    },

    async add_to_collection({ dispatch, commit }, payload = []) {
      try {
        const res = await api.post(`/v1/userCollections/add_to_collection`, payload)
            // Verifica a resposta
          if (res?.data?.error) {
            toast.warning("Erro ao cadastrar", {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            return { error: res.data.error };
          } else {
            toast.success("Cadastrada com sucesso", {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            return { data: res?.data?.result };
          }
            /*commit("GET_USERSCOLLECTIONS", res?.data);
            //dispatch("alert/set_alert", {alert_message: "Cadastrada com sucesso!", type_message: 'alert-success'}, { root: true });
          
            toast.success("Cadastrada com sucesso", {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });*/
          } catch (error) {
          // Lida com erros
            console.log(error);    
            toast.warning("Algo deu errado! Tente novamente mais tarde", {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            
            // Retorna o erro para capturar no "then"
            return { error: error.message || error };
          } finally {
            console.log('Requisição finalizada');
          }
    },

  },
  mutations: {
    GET_USERSCOLLECTIONS(state, data) {
      state.userCollections = data; 
    },
    ERROR_USERSCOLLECTION(state, data) {
      console.log(data);
    },
   
    /*LIST_FILTER_COLLECTION(state, filter) {
      state.filter_collection = state.userCollections.filter((userCollection) => {
        return userCollection.client.toLowerCase().includes(filter.toLowerCase()) ||
          userCollection.quantity.toString().includes(filter);
          // Adicione mais condições conforme necessário para outros campos
        });
      },*/
  }
}

